class SpinnerState {
  public isSpinning = false;
}

export { SpinnerState };
